import { render, staticRenderFns } from "./noZklist.vue?vue&type=template&id=2c35d6ea&scoped=true&"
import script from "./noZklist.vue?vue&type=script&lang=js&"
export * from "./noZklist.vue?vue&type=script&lang=js&"
import style0 from "./noZklist.vue?vue&type=style&index=0&id=2c35d6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35d6ea",
  null
  
)

export default component.exports